import { Vertex } from '@thirdPartyLibraries/three-mesh-halfedge/src';
import HalfEdgeMesh from '@three/common/halfEdgeMesh/HalfEdgeMesh';



export async function reduceBorder(mesh: HalfEdgeMesh, stride: number): Promise<void> {
  if (stride < 2) return;

  while (true) {
    const loop = mesh.getConnectedBorderVertices();
    const L = loop.length;
    if (L < 3) break;

    const toCollapse: Array<[Vertex, Vertex]> = [];
    const used = new Set<number>();

    for (let i = 0; i < L - 1; i += stride) {
      const a = loop[i];
      const b = loop[(i + 1) % L];

      const ia = a.id, ib = b.id;
      if (used.has(ia) || used.has(ib)) continue;

      const he = a.getHalfedgeToVertex(b);
      if (!he || (he.face && he.twin?.face)) continue;

      toCollapse.push([a, b]);
      used.add(ia); used.add(ib);
    }

    if (toCollapse.length === 0) break;

    let succeeded = 0;
    for (const [src, dst] of toCollapse) {
      if (mesh.halfEdges.edgeCollapse(src, dst)) {
        succeeded++;
      }
    }

    if (succeeded === 0) break;
  }
  mesh.calculateBorderVertices();
}

